<template>
    <div>
        <v-card height="100" flat color="light-blue lighten-3">
            <div class="container-fluid">
                
                    <div>
                    <v-form @submit.stop.prevent="searchListings" class> 
                            <v-container>
                                <v-row>                        
                                    <v-col  
                                        cols="11"                          
                                        md="11"
                                        sm="11"
                                    >
                                        <v-text-field
                                            v-model="search"
                                            filled
                                            name="search"
                                            single-line
                                            label="Enter City or MLS#"
                                            append-icon="mdi-magnify"
                                            clearable
                                            @keyup="formatSearch"
                                            @click:append="searchListings"
                                        >
                                        </v-text-field>

                                    </v-col>
                                    <!-- <v-col
                                        
                                        md='2'
                                        class="d-none d-md-inline"
                                    >
                                        <v-select
                                        v-model="totalBeds"
                                        :items="beds"
                                        label="Beds"
                                        item-text="label"
                                        item-value="value"
                                        filled
                                        background-color="light-blue lighten-3"
                                        
                                        
                                        ></v-select>     
                                    </v-col> 
                                    <v-col
                                        
                                        md='2'
                                        class="d-none d-md-inline"
                                    >
                                        <v-select
                                        v-model="totalBaths"
                                        :items="baths"
                                        label="Baths"
                                        item-text="label"
                                        item-value="value"
                                        filled
                                        background-color="light-blue lighten-3"
                                        
                                        
                                        ></v-select>     
                                    </v-col>   -->
                                    <v-col
                                        md='1'
                                    >
                                        <v-btn color="light-blue" fab small type='submit'><v-icon>mdi-magnify</v-icon></v-btn>
                                    </v-col>  
                                </v-row>
                            </v-container>                   
                        </v-form>   
                    </div>

            </div>
            
            
        
        </v-card>
        <v-chip              
          class="ma-2"
          color="teal"
          text-color="white"   
          v-if="total != null"   
        >
          {{ total }} Results
        </v-chip>
        <v-chip
                v-if="this.$route.query.City"
                class="ma-2"
                close
                color="teal"
                text-color="white"
                @click:close="resetSearch"
            >
                {{ this.search }}
            </v-chip>
            <v-chip
                v-if="this.$route.query.maxBeds"
                class="ma-2"
                close
                color="teal"
                text-color="white"
                @click:close="closeBeds"
            >
                Bedrooms: {{ totalBeds }}+
            </v-chip>
    </div>
</template>

<script>
    export default {
        name: "Search",
        props:{
            total: Number,
            search: String
        },
        data() {
            return {
            
                query: [],
                totalBeds: "Any",
                beds: [
                    {label:'Any', value:'Any'},
                    {label:'1+', value:'1'},
                    {label:'2+', value:'2'},
                    {label:'3+', value:'3'},
                    {label:'4+', value:'4'},
                    {label:'5+', value:'5'},
                ],
                totalBaths: "Any",
                baths: [
                    {label:'Any', value:'Any'},
                    {label:'1+', value:'1'},
                    {label:'2+', value:'2'},
                    {label:'3+', value:'3'},
                    {label:'4+', value:'4'},
                    {label:'5+', value:'5'},
                ],
            }
        },
        
        methods:{
            searchListings(){
                if((this.totalBeds != 'Any' && this.totalBaths != 'Any') || (this.totalBeds == 'Any' && this.totalBaths != 'Any')|| (this.totalBeds != 'Any' && this.totalBaths == 'Any')){
                // this.query = [{search: this.search}, {beds: this.totalBeds}, {baths: this.totalBaths}]
                this.query = this.search, this.totalBeds, this.totalBaths
                console.log(this.totalBeds)
                console.log(this.query)
                console.log(this.totalBaths)
                    if(this.search){
                        console.log(this.search)
                        let url = "/listings?limit=200&City="+this.search+"&maxBeds="+this.totalBeds;
                        console.log(url)
                        this.$router.push(url); 
                    }else{
                        let url = "/listings?limit=200&maxBeds="+this.totalBeds;
                        console.log(url)
                        this.$router.push(url); 
                        
                    }
                
                }else if ((this.totalBeds == 'Any' && this.totalBaths == 'Any')){
                    // this.query = [{search: this.search}, {beds: this.totalBeds}, {baths: this.totalBaths}]
                    if(this.search != ''){
                    this.query = "limit=200&City="+this.search;
                    }else{
                        this.query = "limit=200"
                    }
                    console.log(this.query)
                    let url = "/listings?"+this.query;
                    this.$router.push(url);
                }
            
            },
            formatSearch() {
                if (this.search) {
                    this.search = this.search.toString()
                    this.search = this.search.charAt(0).toUpperCase() + this.search.slice(1)
                }
            },
            closeBeds(){
                this.totalBeds = 'Any';
                this.searchListings();
            },
            resetSearch(){
                this.search = '';
                this.searchListings();
            }
            
        },
        created(){
            if(this.$route.query.City){
                this.search = this.$route.query.City;
                console.log(this.$route.query)
            }
            if(this.$route.query.mlsid){
                this.search = this.$route.query.mlsid;
                console.log(this.$route.query)
            }
            if(this.$route.query.maxBeds){
                this.totalBeds = this.$route.query.maxBeds
            }
        },
        
    }
</script>

<style scoped>

</style>